<div class="andre__produkter">

    <h2 mdcHeadline5>Andre billetter</h2>

    <div class="options">
        <button mdc-button outlined [disabled]="disabled" (click)="addStab()" class="button-no-bg">Stabsbillett</button>
        <button mdc-button outlined [disabled]="disabled" (click)="addLedsager()" class="button-no-bg">Ledsager</button>
        <button mdc-button outlined [disabled]="disabled" (click)="betalKampanje()" class="button-no-bg">Kupong</button>
        <span [title]="fribillett_unntatt ? 'Fribilletter er ikke tillatt for denne forestillingen' : null" class="fribillett-wrapper">
            <button mdc-button outlined [disabled]="disabled || fribillett_unntatt" (click)="addFribillett()" class="button-no-bg">Fribillett</button>
        </span>
    </div>

</div>